import { makeAutoObservable, onBecomeObserved } from "mobx"

import { notify } from "@src/app/components/notify"
import { APIPagination, catchErrors, invoicesApi } from "@src/shared/api"
import { InvoiceResponse } from "@src/shared/api/generated"

export class PaymentLinkStore {
  id: string

  isLoading = true

  loadPaymentLink = async () => {
    try {
      this.isLoading = true

      const { data: result } = await invoicesApi.getInvoice(this.id)

      if (result.success) {
        this.paymentLink = result.data
      } else {
        notify.error()
      }
    } catch (error) {
      notify.error()
    } finally {
      this.isLoading = false
    }
  }
  pageSize = 25
  paymentLink?: InvoiceResponse
  resolvePayment = async () => {
    try {
      this.isLoading = true

      const { data: result } = await invoicesApi.resolveInvoice(this.id)

      if (result) {
        notify.success("Invoice resolved")
      }

      return result
    } catch (error: any) {
      catchErrors(error)
    } finally {
      this.isLoading = false
    }

    return null
  }

  total?: APIPagination["total"]
  constructor(id: string) {
    this.id = id

    makeAutoObservable(this)

    onBecomeObserved(this, "paymentLink", this.loadPaymentLink)
  }
}
